import React from 'react';
import { Box } from 'react-layout-components';


class HomeHeader extends React.Component {

    render() {

        const {children, ...props} = this.props

        const _getWidth = () => {
            if(window.innerWidth >= 1200)
                return 1200 - 32
            if(window.innerWidth >= 992)
                return 992 - 32
            if(window.innerWidth >= 768)
                return 768 - 32
            return 'calc(100% - 16px)'
        }

        return (
            <Box width="100%" center {...props}>
                <Box width={_getWidth()}>{children}</Box>
            </Box>
        )
    }

}

export default HomeHeader


// WEBPACK FOOTER //
// ./src/components/common/Container.js